module.exports = __webpack_public_path__ + "assets/img/visible_m.34b30d03.svg";